module.exports = {
  array: Array.isArray,
  primitive: function(s) { return typeof s === 'string' || typeof s === 'number'; },
};



//////////////////
// WEBPACK FOOTER
// ../~/snabbdom/is.js
// module id = 47
// module chunks = 0